import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.reviewops.industry.tagging.review');
import { Input } from '@angular/core';

interface AmbiguityType {
    type: string;
    title: string;
    description: string;
}

interface TaggingReviewData {
    status?: string;
    review_required?: boolean;
    summary?: string;
    notice?: string;
    ambiguity_types?: AmbiguityType[];
    data_quality_types?: AmbiguityType[];
    financial_validation?: { status?: string; reason?: string; };
    peer_validation?: { status?: string; reason?: string; };
    review_reason?: string;
    potential_secondary_industry?: string | null;
    financial_validation_status?: string;
}

@Component({
    selector: 'wiz-component-reviewops-industry-tagging-review',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.reviewops.industry.tagging.review/view.scss */
/* src/app/component.reviewops.industry.tagging.review/view.scss: no such file or directory */`],
})
export class ComponentReviewopsIndustryTaggingReviewComponent {
    @Input() review: TaggingReviewData = {};
}

export default ComponentReviewopsIndustryTaggingReviewComponent;